import React from "react";
import { Box } from "@mui/material";

type PropsType = {
  isActive: boolean;
};

const DURATION = 6000;
const inActiveWidth = 6;
const activeWidth = 20;
const circleWidth = 2;
const radius = (activeWidth - circleWidth * 2) / 2;
const circumference = 2 * Math.PI * radius;

const ProgressDot: React.FC<PropsType> = ({ isActive }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: activeWidth,
        height: activeWidth,
        marginRight: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      {!isActive ? (
        <Box
          sx={{
            width: inActiveWidth,
            height: inActiveWidth,
            borderRadius: "50%",
            backgroundColor: "#646464",
          }}
        />
      ) : (
        <>
          <Box
            sx={{
              position: "absolute",
              width: activeWidth,
              height: activeWidth,
              borderRadius: "50%",
              border: `${circleWidth}px solid #e3e3e3`,
              boxSizing: "border-box",
            }}
          />
          <svg
            width={activeWidth}
            height={activeWidth}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              transform: "rotate(-90deg)",
            }}
          >
            <circle
              cx={activeWidth / 2}
              cy={activeWidth / 2}
              r={radius}
              fill="transparent"
              stroke="#1976d2"
              strokeWidth={circleWidth}
              strokeDasharray={circumference}
              strokeDashoffset={circumference}
            >
              <animate attributeName="stroke-dashoffset" from={circumference} to={0} dur={`${DURATION}ms`} repeatCount="indefinite" />
            </circle>
          </svg>
        </>
      )}
    </Box>
  );
};

export default ProgressDot;
